import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isLargeScreen } from '../../../../../../../global.variable';
import { AppService } from '../../../../../../app.service';
import { UserProfileService } from '../../../../../../profile/user-profile/user-profile.service';
import { ConfirmDialogComponent } from '../../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../../../../../shared/components/file-upload/file-upload.component';
import { MediaPreviewComponent } from '../../../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../../shared/services/toaster.service';
import { JobsService } from '../../../../jobs/jobs.service';
import { HolAndMessageService } from '../../../hol-and-message.service';

@Component({
  selector: 'gtapp-add-edit-hand-over-log',
  templateUrl: './add-edit-hand-over-log.component.html',
  styleUrl: './add-edit-hand-over-log.component.scss',
  standalone: false,
})
export class AddEditHandOverLogComponent implements OnInit, OnDestroy {
  // patrol event params
  patrolEventDataList: any = [];
  patrolEventRows: number = 10;
  patrolEventPrevious: number = 0;
  patrolEventPageNum: number = 1;
  patrolEventTotalCount: number = 0;
  patrolEventParams: any = {};
  selectedPatrolEvents: any = [];
  selectedPatrolEventIds: any = [];
  previouslySelectedPatrolEventIds: any = [];
  alreadySentPatrolEventIds: any = [];

  // not patrol event params

  // nonPatrolEventRows: number = 10;
  // nonPatrolEventPrevious: number = 0;
  // nonPatrolEventPageNum: number = 1;
  // nonPatrolEventTotalPages: number = 0;
  // nonPatrolEventTotalCount: number = 0;
  // nonPatrolEventParams: any = {};
  selectedNonPatrolEvents: any = [];

  // previouslySelectedNonPatrolEventIds: any = [];

  selectedEvents: any = [];
  selectedEventsDataIndexList: any = [];

  currentStep: number = 1;
  handOverLogDescription: string = '';

  recipientList: any = [];
  selectedRecipients: any = [];
  recipientSearchList: any = [];
  handOverLogRecipientsNextCursor: string = '';

  selectedHandOverLogId: string = '';
  selectedGuardId: string = '';
  selectedHandOverLogData: any;

  subscriberUserId: any;

  handOverLogCreated: boolean = false;

  isAdmin: boolean = this.dataCheckService?.isUserAdmin();
  isDispatcherUser = this.dataCheckService.isDispatchUser();

  routeSubscription: any;

  dialogRef: any;
  newComment: string = '';
  previousComment: string = '';
  largeView = isLargeScreen;

  constructor(
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
    private jobService: JobsService,
    private handOverLogService: HolAndMessageService,
    private profileService: UserProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private _location: Location,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.routeSubscription = this.route.params.subscribe({
      next: (params) => {
        if (params?.['hKey']) {
          this.selectedHandOverLogId = atob(params?.['hKey']);
        }
        if (params?.['gKey']) {
          this.selectedGuardId = atob(params?.['gKey']);
        }
      },
    });
  }
  ngOnInit(): void {
    if (this.selectedHandOverLogId) {
      this.getHandOverLogDetailData();
    } else {
      this.getAlreadySentPatrolEventIds();
      this.getRecipients();
      this.getNonPatrolEvents();
    }

    const userData = this.appService.getUserData();
    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;
  }
  ngOnDestroy(): void {
    if (!this.handOverLogCreated) this.updateDrafts();

    if (!this.routeSubscription) this.routeSubscription?.unsubscribe();
  }

  getHandOverLogDetailData() {
    this.handOverLogService
      .retrieveHandOverLog(this.selectedHandOverLogId, {
        userId: this.selectedGuardId,
      })
      .subscribe((resp: any) => {
        if (resp?.status === 'success') {
          this.selectedHandOverLogData = resp?.data;

          this.selectedHandOverLogData.received_by =
            this.selectedHandOverLogData?.recipients?.find(
              (guard: any) => guard?.opened,
            );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resp['message'],
          });
        }
      });
  }
  updateDrafts() {
    const recipient_ids = [
      ...new Set(this.selectedRecipients?.map((user: any) => user?.id)),
    ];

    if (recipient_ids?.length)
      sessionStorage.setItem(
        'handOverLogDraftSelectedAssignees',
        JSON.stringify(recipient_ids),
      );

    const selectedItemsIds = JSON.parse(
      JSON.stringify(this.selectedPatrolEventIds),
    );
    if (this.selectedNonPatrolEvents?.length) {
      sessionStorage.setItem('handOverLogUpdate', '1');
    }

    if (
      this.areArraysSame(
        selectedItemsIds,
        this.previouslySelectedPatrolEventIds,
      )
    )
      return;

    this.profileService
      .updateHandOverLogDraft({
        selected_event_ids: selectedItemsIds,
      })
      .subscribe((response: any) => {
        if (selectedItemsIds?.length)
          sessionStorage.setItem('handOverLogUpdate', '1');
      });
  }
  areArraysSame(arr1: any[], arr2: any[]): boolean {
    if (arr1?.length !== arr2?.length) {
      return false;
    }

    arr1?.sort();
    arr2?.sort();

    for (let i = 0; i < arr1?.length; i++) {
      if (arr1?.[i] !== arr2?.[i]) {
        return false;
      }
    }

    return true;
  }

  getNonPatrolEvents() {
    let params: any = {};
    let body: any = {};

    this.handOverLogService
      .getHandOverLogRelatedNonPatrolEvents(body, params)
      .subscribe((resp: any) => {
        if (resp?.status === 'success') {
          this.selectedNonPatrolEvents = resp?.data;
          this.formatCompleteList();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resp['message'],
          });
        }
      });
  }

  getAlreadySentPatrolEventIds() {
    this.spinnerService.show();
    let params: any = { already_logged_event_ids: 1 };

    this.handOverLogService
      .getHandOverLogRelatedPatrolEvents({}, params)
      .subscribe((resp: any) => {
        if (resp?.status === 'success') {
          this.alreadySentPatrolEventIds = resp?.data;
          this.getPatrolEvents();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resp['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  async getDraftedPatrolEvents() {
    return new Promise((resolve) => {
      this.spinnerService.show('Fetching drafts');
      let params: any = { previously_drafted_ids: 1 };
      this.handOverLogService
        .getHandOverLogRelatedPatrolEvents({}, params)
        .subscribe((resp: any) => {
          if (resp?.status === 'success') {
            resolve(resp?.data || []);
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: resp['message'],
            });

            resolve([]);
          }
        });
    });
  }
  getPatrolEvents() {
    this.spinnerService.show('Fetching updates');
    let params: any = {};
    let body: any = {};
    if (this.patrolEventRows) {
      params['rows'] = this.patrolEventRows;
    }
    if (this.patrolEventPrevious) {
      params['previous'] = this.patrolEventPrevious;
    }
    if (this.alreadySentPatrolEventIds) {
      body.already_logged_event_ids = this.alreadySentPatrolEventIds;
    }
    this.handOverLogService
      .getHandOverLogRelatedPatrolEvents(body, params)
      .subscribe(async (resp: any) => {
        if (resp?.status === 'success') {
          this.patrolEventDataList = resp?.data;
          this.patrolEventTotalCount = resp?.total_size;

          const responseData = await this.getDraftedPatrolEvents();

          this.selectedPatrolEvents = responseData;

          this.patrolEventDataList?.forEach((event: any) => {
            if (event?.hand_over_log_draft) {
              const isItemPresent = this.selectedPatrolEvents?.some(
                (selectedEvent: any) => selectedEvent?.id === event?.id,
              );
              if (!isItemPresent) {
                this.selectedPatrolEvents.push(event);
              }
            }
          });
          this.selectedPatrolEventIds = [
            ...new Set(
              this.selectedPatrolEvents?.map(
                (selectedEvent: any) => selectedEvent?.id,
              ),
            ),
          ];

          this.previouslySelectedPatrolEventIds = JSON.parse(
            JSON.stringify(this.selectedPatrolEventIds),
          );
          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resp['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  onChangePatrolEventPagination(event: any) {
    this.patrolEventPrevious = event.previous;
    this.patrolEventPageNum = event.pageNum;
    this.patrolEventRows = event.pageSize;
    this.getPatrolEvents();
  }

  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: file?.file_url,
        timeStamp: file.updated_at,
        mediaExtension: file?.file_extension,
      },
    });
  }
  getRecipients() {
    let params: any = { rows: 25 };

    if (this.handOverLogRecipientsNextCursor) {
      params['next_cursor'] = this.handOverLogRecipientsNextCursor;
    }

    this.jobService.getUserList(params).subscribe(async (response: any) => {
      if (response?.status != 'success') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response?.message,
        });
        return;
      }
      this.recipientList.push(...(response?.data || []));
      this.handOverLogRecipientsNextCursor = response?.next_cursor;

      const savedAssigneeIds: any = JSON.parse(
        sessionStorage.getItem('handOverLogDraftSelectedAssignees') || '[]',
      );
      sessionStorage.removeItem('handOverLogDraftSelectedAssignees');

      if (savedAssigneeIds?.length) {
        this.recipientList?.forEach((user: any) => {
          if (savedAssigneeIds?.includes(user?.id)) {
            this.addSelectedAssignee(user);
          }
        });
      } else {
        this.makeAssigneeSelectionChanges();
      }
      this.focusElement('holDescriptionField');
    });
  }

  removeSelectedAssignee(deleteAssignee: any) {
    this.selectedRecipients = this.selectedRecipients?.filter(
      (assignee: any) => assignee?.id !== deleteAssignee?.id,
    );
    this.makeAssigneeSelectionChanges();
  }
  addSelectedAssignee(addAssignee: any) {
    if (addAssignee?.id) {
      if (
        this.selectedRecipients?.some(
          (assignee: any) => assignee?.id === addAssignee?.id,
        )
      ) {
        this.toasterService.setMessage({
          errorMessage: 'assignee already added',
          successMessage: '',
        });
      } else {
        this.selectedRecipients.push(addAssignee);
        if (
          !this.recipientList?.some(
            (assignee: any) => assignee?.id === addAssignee?.id,
          )
        ) {
          this.recipientList.push(addAssignee);
        }
      }

      this.makeAssigneeSelectionChanges();
    }
  }
  selectUnselectEvents(event: any) {
    const isItemPresent = this.selectedPatrolEvents?.some(
      (selectedEvent: any) => selectedEvent?.id === event?.id,
    );
    if (isItemPresent) {
      this.selectedPatrolEvents = this.selectedPatrolEvents?.filter(
        (selectedEvent: any) => selectedEvent?.id !== event?.id,
      );
    } else {
      this.selectedPatrolEvents.push(event);
    }
    this.selectedPatrolEventIds = [
      ...new Set(
        this.selectedPatrolEvents?.map(
          (selectedEvent: any) => selectedEvent?.id,
        ),
      ),
    ];
  }

  addRemovessignee(assignee: any) {
    assignee.selected = !assignee?.selected;
    if (assignee.selected) {
      this.addSelectedAssignee(assignee);
    } else {
      this.removeSelectedAssignee(assignee);
    }
  }
  makeAssigneeSelectionChanges() {
    this.recipientList = this.recipientList?.filter(
      (user: any) => user?.id != this.subscriberUserId,
    );
    this.recipientList.forEach((assignee: any) => {
      assignee.selected = this.selectedRecipients?.some(
        (selectedAssignee: any) => selectedAssignee?.id === assignee?.id,
      );
    });
  }
  searchAssignee(event?: any) {
    if (event.target.value?.length <= 2) return;

    this.jobService
      .getUserList({ search_str: event?.target?.value })
      .subscribe(async (response: any) => {
        if (response['status'] == 'success') {
          this.recipientSearchList = response?.data?.filter(
            (value1: any) =>
              !this.selectedRecipients?.some(
                (value2: any) => value1?.id === value2?.id,
              ),
          );
        }
      });
  }

  createhandOverLog() {
    this.handOverLogCreated = true;
    let body: any = {
      description: this.handOverLogDescription,
      recipient_ids: [
        ...new Set(this.selectedRecipients?.map((user: any) => user?.id)),
      ],
    };
    const user_update_ids: any = [];
    const non_patrol_event_ids: any = [];
    const user_update_id_order_list: any = [];
    const non_patrol_event_id_order_list: any = [];
    this.selectedEvents.forEach((event: any, index: any) => {
      if (event?.company_id) {
        user_update_id_order_list.push({ id: event?.id, index });
        user_update_ids.push(event?.id);
      } else {
        non_patrol_event_id_order_list.push({ id: event?.id, index });
        non_patrol_event_ids.push(event?.id);
      }
    });
    if (!non_patrol_event_ids?.length && !user_update_ids?.length) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Updates Missing',
      });
      return;
    }

    if (user_update_ids?.length) {
      body.user_update_ids = [...new Set(user_update_ids)];
    }
    if (non_patrol_event_ids?.length) {
      body.non_patrol_event_ids = [...new Set(non_patrol_event_ids)];
    }
    let orderDict: any = {};
    if (user_update_id_order_list?.length)
      orderDict.user_update_id_order_list = user_update_id_order_list;
    if (non_patrol_event_id_order_list?.length)
      orderDict.non_patrol_event_id_order_list = non_patrol_event_id_order_list;

    body.event_order_dict = orderDict;
    this.handOverLogService.createHandOverLog(body).subscribe((resp: any) => {
      if (resp?.status === 'success') {
        sessionStorage.removeItem('handOverLogDraftCount');
        sessionStorage.removeItem('handOverLogUpdate');
        this.router.navigate(['/']);
        this.toasterService.setMessage({
          successMessage: resp['message'],
          errorMessage: '',
        });
      } else {
        this.handOverLogCreated = false;
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: resp['message'],
        });
      }
    });
  }

  // commentOnLog() {
  //   sessionStorage.setItem(
  //     'commentOnHOLData',
  //     JSON.stringify({
  //       id: this.selectedHandOverLogId,
  //       description: this.selectedHandOverLogData?.description,
  //     })
  //   );
  //   let openedUser = this.selectedHandOverLogData?.recipients?.find(
  //     (user: any) => user?.opened
  //   );
  //   if (this.subscriberUserId === openedUser?.id) {
  //     openedUser = this.selectedHandOverLogData?.created_by;
  //   }

  //   this.router.navigate(['/message'], { fragment: openedUser?.id });
  // }

  sendLater() {
    if (
      !this.selectedPatrolEventIds?.length &&
      !this.selectedNonPatrolEvents?.length
    )
      this.selectedRecipients = [];
    this._location.back();
  }
  openCamPopup() {
    const dailogRef = this.dialogService.open(FileUploadComponent, {
      data: {
        showFrom: 'handOverLog',
      },
    });
    dailogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        // this.newComment = value.newComment;
        // this.onFileSubmit(value);
        if (!value?.actualFileUpload) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Please add a photo',
          });
        } else {
          this.spinnerService.show('Uploading - Please Wait');
          let fileData: FormData = new FormData();

          fileData.append('file', value?.actualFileUpload);
          if (value?.newComment) {
            fileData.append('comment', value?.newComment);
          }
          let url = `hand_over_log/update_hol_note`;

          fileData.append('image_source', value?.uploadType);

          if (value?.exifData && Object.values(value?.exifData)?.length) {
            fileData.append('exif_data', JSON.stringify(value?.exifData));
          }
          this.appService.formDataApi(url, fileData).then((resp: any) => {
            if (resp?.status === 'success') {
              this.selectedNonPatrolEvents = [
                resp?.data,
                ...this.selectedNonPatrolEvents,
              ];
              this.formatCompleteList();
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: resp['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: resp['message'],
              });
            }
          });
        }
      } else if (value == 'error') {
        this.toasterService.setMessage({
          errorMessage: 'Unable to access your camera',
        });
      }
    });
  }

  clearAndFocusTextBox(elementId: string) {
    this.newComment = '';
    this.previousComment = '';
    this.focusElement(elementId);
    this.focusElement('holDescriptionField');
  }
  focusElement(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, 100);
  }

  addEditComment(requestRef: any, eventData?: any) {
    if (eventData?.id) {
      //edit comment
      this.previousComment = eventData?.detail;
      this.newComment = eventData?.detail;
    } else {
      this.previousComment = '';
      this.newComment = '';
    }

    this.dialogRef = this.dialogService.open(
      requestRef,
      {
        data: eventData,
      },
      this.viewContainerRef,
    );
    this.dialogRef?.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse) {
        this.spinnerService.show();
        let body: any = { comment: this.newComment };
        let params: any = {};
        if (dialogResponse?.id) {
          body.event_id = dialogResponse?.id;
          params.update_comment = 1;
        }

        this.handOverLogService
          .updateHolNote(body, params)
          .subscribe((resp: any) => {
            if (resp?.status === 'success') {
              const addedUpdatedItem = resp?.data;
              const index = this.selectedNonPatrolEvents?.findIndex(
                (item: any) => item?.id === addedUpdatedItem?.id,
              );

              if (index !== -1) {
                // Replace the existing dictionary
                this.selectedNonPatrolEvents[index] = { ...addedUpdatedItem };
                const fullListindex = this.selectedEvents?.findIndex(
                  (item: any) =>
                    item?.id === addedUpdatedItem?.id && !item?.company_name,
                );
                if (fullListindex !== -1)
                  this.selectedEvents[fullListindex] = { ...addedUpdatedItem };
              } else {
                // Add the new dictionary to the beginning
                this.selectedNonPatrolEvents?.unshift(addedUpdatedItem);
                this.formatCompleteList();
              }

              this.newComment = '';
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: resp['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: resp['message'],
              });
            }
          });
      }
    });
  }
  deleteNonPatrolEvent(eventData: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();

        this.handOverLogService
          .updateHolNote({ event_id: eventData?.id }, { delete_event: 1 })
          .subscribe((resp: any) => {
            if (resp?.status === 'success') {
              this.selectedNonPatrolEvents =
                this.selectedNonPatrolEvents?.filter(
                  (event: any) => event?.id !== eventData?.id,
                );

              this.formatCompleteList();
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: resp['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: resp['message'],
              });
            }
          });
      }
    });
  }

  formatCompleteList() {
    const eventMap = new Map<string, any>();

    const completeList = JSON.parse(
      JSON.stringify([
        ...(this.selectedNonPatrolEvents || []),
        ...(this.selectedPatrolEvents || []),
      ]),
    );

    completeList?.forEach((event: any) => {
      const uniqueKey = `${event?.id}_${event?.company_id ?? 'no_company'}`;

      eventMap.set(uniqueKey, event);
    });

    const reorderedEvents = this.selectedEvents
      .map((event: any) => {
        const uniqueKey = `${event?.id}_${event?.company_id ?? 'no_company'}`;
        return eventMap.get(uniqueKey) ?? event;
      })
      .filter((event: any) =>
        eventMap.has(`${event?.id}_${event?.company_id ?? 'no_company'}`),
      );

    const newEvents = Array.from(eventMap.values()).filter(
      (event) =>
        !reorderedEvents.some((reordered: any) => reordered?.id === event?.id),
    );

    // Merge while keeping the order of manually reordered events
    this.selectedEvents = [...newEvents, ...reorderedEvents];

    this.selectedEventsDataIndexList = Array.from(
      { length: this.selectedEvents?.length || 0 },
      (_, i) => i + 1,
    );
  }

  dropSelectedEvent(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.selectedEvents,
      event.previousIndex,
      event.currentIndex,
    );
  }
  onPositionChange(currentIndex: number, event: any) {
    const input = event.target as HTMLInputElement;
    const newPosition = input.value;
    let newIndex = Number(newPosition) - 1;

    if (isNaN(newIndex) || newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= this.selectedEvents?.length) {
      newIndex = this.selectedEvents?.length - 1;
    }

    const movedItem = this.selectedEvents?.splice(currentIndex, 1)[0];
    this.selectedEvents?.splice(newIndex, 0, movedItem);
    setTimeout(() => {
      input.value = (newIndex + 1).toString();
    });
  }
}
